import { NodeSelection, TextSelection } from 'prosemirror-state'

import type { Command } from 'common/Prose/Commands'
import { schema } from 'prose-core'
import { setPreservedSelectionForTrackedChanges } from 'common/Prose/Plugins/TrackChanges/utils'
import { setTrackedChangeCommand } from 'common/Prose/Plugins/TrackChanges/commands'
import { CommandName } from 'common/Prose/Plugins/TrackChanges/commands/types'

export const splitListItemOnGapCursor: Command = (state, dispatch) => {
  const { $from, empty } = state.selection

  if (!empty) {
    return false
  }

  if ($from.depth < 1) {
    return false
  }

  const parentNode = $from.node($from.depth - 1)
  if (parentNode.type.groups.includes('list') && parentNode.type !== schema.nodes.toggle_list) {
    // this is the case if we have a gap cursor selection
    const tr = state.tr

    tr.delete($from.pos, $from.end())

    const newContent = $from.node().cut($from.pos - $from.start(), $from.node().nodeSize - 2).content
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    tr.insert($from.pos + 1, state.schema.nodes.list_item.createAndFill({ depth: parentNode.attrs.depth }, newContent)!)
    tr.setSelection(
      !newContent.firstChild || newContent.firstChild.type.groups.includes('textWrap')
        ? TextSelection.create(tr.doc, $from.pos + 3)
        : NodeSelection.create(tr.doc, $from.pos + ($from.pos === $from.start() ? 4 : 2)),
    )

    setPreservedSelectionForTrackedChanges(tr)
    setTrackedChangeCommand(tr, { name: CommandName.SPLIT_LIST_ITEM_ON_GAP_CURSOR })
    dispatch?.(tr)

    return true
  }

  return false
}
